"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvidersAuthSuiteService = exports.providersAuthSuiteService = void 0;
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var models_1 = require("../../models");
var mvpdPath = "mvpd";
var getMvpdProvider = function (request) {
    var mvpdInfoPath = "info";
    var requestParams = [models_1.AuthSuiteRequestParams.LogoSchema, models_1.AuthSuiteRequestParams.ActivationCode];
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get({
        path: "".concat(mvpdPath, "/").concat(request.mvpdCode, "/").concat(mvpdInfoPath),
        request: request,
        requestParams: requestParams,
    });
};
var getMvpdProviders = function (request) {
    var requestParams = [
        models_1.AuthSuiteRequestParams.FilterType,
        models_1.AuthSuiteRequestParams.LogoSchema,
        models_1.AuthSuiteRequestParams.ActivationCode,
        models_1.AuthSuiteRequestParams.TopProvidersLimit,
    ];
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get({
        path: mvpdPath,
        request: request,
        requestParams: requestParams,
    });
};
exports.providersAuthSuiteService = {
    getMvpdProvider: getMvpdProvider,
    getMvpdProviders: getMvpdProviders,
};
var ProvidersAuthSuiteService = /** @class */ (function () {
    function ProvidersAuthSuiteService() {
        return exports.providersAuthSuiteService;
    }
    return ProvidersAuthSuiteService;
}());
exports.ProvidersAuthSuiteService = ProvidersAuthSuiteService;
